<template>
  <div class="row">
    <!--  用户列表  -->
    <div class="flex xs12">
      <va-card title="导师申请表">
        <div class="flex xs12">
          <va-button-group>
            <va-button
                class="mb-2"
                flat
                disabled
                color="gray"
            >处理状态：
            </va-button>
            <va-button
                flat
                class="mb-2"
                :color="status === data.CODE ? 'info' : 'gray'"
                v-for="data in statusOption"
                v-on:click="handleStatusChange(data.CODE)"
                :key="data.CODE"
            >{{ data.TEXT }}
            </va-button>
          </va-button-group>
          <va-button class="mb-2" flat disabled color="danger">总计{{ totalCount }}条结果</va-button>
        </div>
        <va-data-table
            :fields="fields"
            :data="mentorApplications"
            :loading="loading"
            :totalPages="totalPages"
            @page-selected="listMentorApplication"
            api-mode
        >
          <template slot="avatar" slot-scope="props">
            <img :src="props.rowData.avatar" class="data-table-server-pagination---avatar" alt="avatar">
          </template>
          <template slot="actions" slot-scope="props">
            <va-popover message="查看" placement="top">
              <va-button flat small color="gray" icon="fa fa-eye"
                  :to='{path:`getMentorApplication/${props.rowData.userUid}`}'/>
            </va-popover>
            <va-popover message="删除" placement="top">
              <va-button flat small color="gray" icon="fa fa-trash"
                  @click="deleteModal = true; deleteUid=props.rowData.userUid"/>
            </va-popover>
          </template>
        </va-data-table>
        <va-modal
            v-model="deleteModal"
            title="删除导师申请"
            okText="提交"
            position="center"
            message="请再次确认是否要删除？"
            @ok="confirmDelete"
        />

      </va-card>
    </div>
  </div>
</template>

<script>

import debounce from 'lodash/debounce'
import mentorApplicationApi from '../../api/mentorApplication'
import { MENTOR_APPLICATION_STATUS } from '@/utils/constants'
import { formatTime } from '@/utils/common'
import commentApi from '@/api/comment'

export default {
  data () {
    return {
      message: ['Required field'],
      // serviceId: 3,
      mentorApplications: [],
      nickName: null,
      loading: true,
      pageNumber: 1,
      pageSize: 10,
      totalCount: 0,
      totalPages: 1,
      mentorExpertFields: [],
      ExpertFieldId: null,
      status: 0,
      statusOption: MENTOR_APPLICATION_STATUS,
      deleteModal: false,
      deleteUid: '',
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:avatar',
          title: '头像',
          width: '60px',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'nickname',
          title: '用户名字',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'userUid',
          title: '用户uid',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'contactInfo',
          title: '微信/手机号',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'createTime',
          title: '创建时间',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:actions',
          title: '操作',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
  },
  created () {
    this.listMentorApplication()
  },
  methods: {
    listMentorApplication (pageNumber = this.pageNumber) {
      this.loading = true
      const params = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        status: this.status,
      }
      mentorApplicationApi.listMentorApplication(params).then(response => {
        this.mentorApplications = response.mentorApplications
        this.mentorApplications.forEach(x => {
          x.createTime = formatTime(x.createTime)
        })
        this.totalPages = response.pages.totalPage
        this.totalCount = response.pages.totalCount
        this.pageNumber = pageNumber
        this.loading = false
      }).catch(error => alert(error))
    },

    search: debounce(function (nickName) {
      this.nickName = nickName
      if (this.nickName === '') {
        this.nickName = null
      }
      this.listMentorInfo()
    }, 400),
    handleStatusChange (status) {
      this.status = status
      this.listMentorApplication()
    },
    confirmDelete () {
      if (this.deleteUid === null) return
      mentorApplicationApi.deleteMentorApplication(this.deleteUid).then(response => {
        if (response.success === true) {
          this.showToast('删除导师申请表成功', {
            duration: 1000,
            icon: 'fa-success',
            position: 'top-center',
            fullWidth: false,
          })
          this.listMentorApplication()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
</style>
